import { Button, Grid } from "@mui/material";
import React, { useState } from "react";
import InputField from "../components/InputField";
import WelcomeTitle from "../components/WelcomeTitle";
import styles from "../styles/authStyles.module.css";
import logo from "../../assets/img/logo.png";
import { useDispatch } from "react-redux";
import { resetPassword } from "../../api/auth";
import { useNavigate, useSearchParams } from "react-router-dom";
import { isClientPreview } from "../../utils/clientPreview";
import ResetPasswordPreview from "./ResetPasswordPreview";

export default function ResetPassword() {
  const [values, setValues] = useState({
    password: "",
    confirmPassword: "",
  });
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);

  const handleValues = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const navigate = useNavigate();



  if (isClientPreview()) {
    return (
      <ResetPasswordPreview
        hasToken={Boolean(token)}
        onSubmit={(password) =>
          dispatch(resetPassword({ token, password: { password } })).then(({ payload }) => Boolean(payload))
        }
      />
    );
  }

  const handlePasswordBlur = (event) => {
    const isValidPassword =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/.test(
        values.password
      );
    setPasswordError(!isValidPassword);
  };

  const handleConfirmPasswordBlur = (event) => {
    const isValidPassword = values.password === values.confirmPassword;
    if (values.confirmPassword !== "") {
      setConfirmPasswordError(!isValidPassword);
    }
  };
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <div className={styles.signin_left}>
            <div>
              <div className={styles.logo}>
                <img src={logo} alt="logo" />
              </div>
              <h1>The Ultimate</h1>
              <h1>Dropshipping Solution</h1>
            </div>
          </div>
        </Grid>
        <Grid
          item
          xs={6}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className={styles.signin_right}>
            <WelcomeTitle
              title="Reset Password"
              subTitle="Create new password"
            />
            <div className={styles.form}>
              <InputField
                label="Password"
                placeholder="Enter new password"
                type="password"
                size="small"
                name="password"
                value={values.password}
                passwordError={passwordError}
                onBlur={handlePasswordBlur}
                onChange={handleValues}
              />
              <InputField
                label="Confirm Password"
                placeholder="Confirm password"
                type="confirmPassword"
                size="small"
                value={values.confirmPassword}
                name="confirmPassword"
                passwordError={confirmPasswordError}
                onBlur={handleConfirmPasswordBlur}
                onChange={handleValues}
              />
              <div className={styles.button_part}>
                <Button
                  variant="lightblue"
                  className="w-full"
                  onClick={() =>
                    dispatch(
                      resetPassword({
                        token: token,
                        password: { password: values.password },
                      })
                    ).then(() => navigate("/signin"))
                  }
                >
                  Send
                </Button>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
